<template>
  <div class="mainPage">
    <el-row>
      <el-col :span="24" style="margin-bottom: 20px">
        <el-button type="primary" @click="toAddNew"
          ><i class="el-icon-plus el-icon--left fw600"></i>新增</el-button
        >
        <el-button type="" @click="showImportDialog"
          ><i class="el-icon-download el-icon--left fw600"></i>导入</el-button
        >
        <el-button type="" @click="changeUseDate">修改券有效期</el-button>
        <el-button type="" @click="showBanchDialog"
          ><i class="el-icon-document-copy el-icon--left fw600"></i
          >批量操作记录</el-button
        >
      </el-col>
      <el-form>
        <el-col :span="5">
          <el-form-item label="优惠券名称:" label-width="90px">
            <el-input
              v-model="queryInfo.condition.couponName"
              placeholder="请输入优惠券名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="优惠券类型:" label-width="100px">
            <el-select v-model="queryInfo.condition.couponType" placeholder="请选择">
              <el-option
                v-for="item in couponTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="可用渠道:" label-width="100px">
            <el-select v-model="queryInfo.condition.couponUseWay" placeholder="请选择">
              <el-option
                v-for="item in couponUseWayList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="优惠券状态:" label-width="100px">
            <el-select v-model="queryInfo.condition.couponStatus" placeholder="请选择">
              <el-option
                v-for="item in couponStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="4"> -->
        <el-button type="primary" class="ml10" @click="search"
          ><i class="el-icon-search el-icon--left fw600"></i>查询</el-button
        >
        <el-button type="" @click="reSet"
          ><i
            v-if="!isLoading"
            class="el-icon-refresh-right el-icon--left fw600"
          ></i
          ><i v-if="isLoading" class="el-icon-loading el-icon--left fw600"></i
          >重置</el-button
        >
        <!-- </el-col> -->
      </el-form>
    </el-row>

    <el-table :data="tableData" stripe style="width: 100%" height="67vh">
      <el-table-column prop="tempId" label="优惠券模版ID" width="180"> </el-table-column>
      <el-table-column prop="couponName" label="券名称" width="180"> </el-table-column>
      <el-table-column prop="couponType" label="券类型"> </el-table-column>
      <el-table-column prop="couponPrice" label="券面值"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column prop="useStartDate" label="使用生效期"> </el-table-column>
      <el-table-column prop="useEndDate" label="使用失效期"> </el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
            <div class="btnBox">
                <div class="toolBtn" @click="toDetail(scope.row)">查看</div>
                <div class="toolBtn" @click="toEdit(scope.row)">编辑</div>
                <div class="toolBtn" @click="copyCoupon(scope.row)">复制</div>
                <div class="toolBtn">删除</div>
                <div class="toolBtn" @click="toUseDetail(scope.row)">详情</div>
                <div class="toolBtn" @click="toOperate()">操作记录</div>
                <div class="toolBtn" @click="toBanch()">批量制券</div>
            </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>

      <ShowDetails  :dialogVisible="isShowDetail" @handleClose='detailDialogClose'></ShowDetails>
      <ImportMember  :dialogImportVisible="isShowImport" @handleImportClose='impotrDialogClose'></ImportMember>
      <ChangeCouponDate  :dialogDateVisible="isShowDate" @handleDateClose='dateDialogClose'></ChangeCouponDate>
      <BanchRecode  :dialogRecordVisible="isShowRecode" @recordDialogClose='recordDialogClose'></BanchRecode>

  </div>
</template>

<script>
import ShowDetails from "./components/showDetails.vue"
import ImportMember from "./components/ImportMember.vue"
import ChangeCouponDate from "./components/ChangeCouponDate.vue"
import BanchRecode from "./components/BanchRecodeList.vue"

export default {
  components:{
    ShowDetails,
    ImportMember,
    ChangeCouponDate,
    BanchRecode,
  },
  data() {
    return {
      total:0,
      queryInfo: {
        pageSize: 10,
        currPage: 1,
        condition: {
          couponName: "",
          couponType: "",
          couponUseWay: "",
          couponStatus: "",
        },
      },
      couponTypeList: [
        {
          value: "1",
          label: "通用券",
        },
        {
          value: "2",
          label: "折扣券",
        },
        {
          value: "3",
          label: "满减券",
        },
      ],
      couponUseWayList: [
        {
          label: "小程序",
          value: "1",
        },
        {
          label: "抖音团购",
          value: "2",
        },
        {
          label: "美团团购",
          value: "3",
        },
      ],
      couponStatusList: [
        {
          label: "正常",
          value: "1",
        },
        {
          label: "作废",
          value: "2",
        },
      ],
      isLoading: false,
      tableData:[
        {
           tempId:'394987',
           couponName:'5折券',
           couponType:'代金券',
           couponPrice:"10.00",
           createTime:'2023-06-15 20:00:00',
           useStartDate:'领取后当天生效',
           useEndDate:'有效期90天',  
        }
      ],
      isShowDetail:false,
      isShowImport:false,
      isShowDate:false,
      isShowRecode:false,
    };
  },
  methods:{
    //打开修改有效期弹框
    changeUseDate(){
      this.isShowDate = true
    },
    //打开批量操作弹框
    showBanchDialog(){
      this.isShowRecode = true
    },
    //打开导入会员弹框
    showImportDialog(){
      this.isShowImport = true
    },
    //前往批量制券
     toBanch(){
         this.$router.push({path:'/banchCreatedCoupon'})
    },
    //前往操作记录
    toOperate(){
       this.$router.push({path:'/couponOperateRecord'})
    },
    //查看详情关闭
    detailDialogClose(e){
      this.isShowDetail = e
    },
    //导入领券会员关闭
    impotrDialogClose(e){
        this.isShowImport = e
    },
    //修改有效期关闭
    dateDialogClose(e){
      this.isShowDate = e
    },
    //批量操作记录谈框
    recordDialogClose(e){
      this.isShowRecode = e
    },
    //详情
    toUseDetail(){
       this.$router.push({path:'/couponUseDetail',})
    },
    //复制券
    copyCoupon(){
        this.$router.push({path:'/couponDetail',query:{pageName:'copy',}})
    },
    //编辑
    toEdit(){
      this.$router.push({path:'/couponDetail',query:{pageName:'edit',}})
    },
    //新建
    toAddNew(){ 
      this.$router.push({path:'/couponDetail',query:{pageName:'add',}})
    },
    //查看详情
    toDetail(row){
      this.isShowDetail = true
    },
    search(){
    //   this.getListData();
    },
    reSet(){
        this.queryInfo.condition = {
          couponName: "",
          couponType: "",
          couponUseWay: "",
          couponStatus: "",
        }
      this.queryInfo.currPage = 1  
      //   this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
    //   this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
    //   this.getListData();
    },
  },
};
</script>

<style lang="less" scoped>
.mainPage {
  width: 95.5%;
  /* height: 100vh; */
  padding: 30px;
  background: #fff;
}
/deep/ .el-button--primary {
  background-color: rgb(245, 154, 35);
  border-color: rgb(245, 154, 35);
  color: #222;
}
.fw600 {
  font-weight: 600;
}
/deep/ .el-button:focus,
.el-button:hover {
  color: #222;
  border-color: #ffe880;
  background-color: #ffe880;
}
/deep/ .el-table th>.cell{
    padding: 10px;
}
.toolBtn{
    padding: 0 10px;
    color: rgb(245,167,86);
    font-size: 12px;
    text-align: center; 
    position: relative;
    cursor: pointer;
}
.toolBtn::after{
  content: "|";
  color: #ddd;
  position: absolute;
  right: 0;
}
.toolBtn:nth-last-child(1)::after{
    content: '';
}
.btnBox{
    display: flex;
    flex-wrap: wrap;
}
</style>